<!-- Toast notifications -->
<p-toast key="clinicCreation"></p-toast>
<p-toast key="register"></p-toast>
<p-toast key="clinicDeletion"></p-toast>
<p-toast key="clinicUpdate"></p-toast>
<p-toast key="clinicToggle"></p-toast>
<p-toast key="passwordReset"></p-toast>

<!-- Context menu -->
<p-contextMenu
  *ngIf="currentRole !== 'hq-clinic-user'"
  #cm
  [model]="menuItems"
  appendTo="body"
></p-contextMenu>
<p-contextMenu
  #nurseCm
  [model]="nurseMenuItems"
  appendTo="body"
  *ngIf="currentRole !== 'hq-clinic-user'"
></p-contextMenu>

<!-- Modern header section -->
<div class="dashboard-header">
  <div class="header-content">
    <div class="header-left">
      <h1 class="dashboard-title">
        <i class="pi pi-building mr-3"></i>
        Admin Dashboard
      </h1>
      <p class="dashboard-subtitle">Manage clinics, users, and nurses</p>
    </div>
    <div class="header-right">
      <div class="stats-cards">
        <div class="stat-card">
          <div class="stat-icon">
            <i class="pi pi-building"></i>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ clinicAmount }}</span>
            <span class="stat-label">Clinics</span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="pi pi-users"></i>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ userAmount }}</span>
            <span class="stat-label">Users</span>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon">
            <i class="pi pi-user"></i>
          </div>
          <div class="stat-content">
            <span class="stat-number">{{ nurseAmount }}</span>
            <span class="stat-label">Nurses</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main content area -->
<div class="dashboard-content">
  <p-tabView class="modern-tabview">
    <!-- Clinics Tab -->
    <p-tabPanel header="Clinics" leftIcon="pi pi-building">
      <div class="tab-content">
        <div class="content-header">
          <div class="header-info">
            <h2 class="section-title">Clinic Management</h2>
            <p class="section-description">
              Register and manage clinic information
            </p>
          </div>
          <div *ngIf="currentRole !== 'hq-clinic-user'" class="flex flex-row">
            <div class="mr-2">
              <button
                pButton
                pRipple
                label="Export Clinics"
                icon="pi pi-file-excel"
                class="modern-button secondary"
                (click)="exportClinicsToExcel()"
              ></button>
            </div>
            <div>
              <button
                pButton
                pRipple
                label="Register Clinic"
                icon="pi pi-plus"
                class="modern-button primary"
                (click)="showRegisterClinicDialog()"
              ></button>
            </div>
          </div>
        </div>

        <div class="table-container">
          <p-table
            #clinicsTable
            [value]="clinics"
            [lazy]="true"
            [paginator]="true"
            (onLazyLoad)="loadClinicsLazy($event)"
            [scrollable]="true"
            [totalRecords]="metaData.totalRecords"
            [loading]="metaData.loading"
            [rows]="10"
            [contextMenu]="cm"
            [(contextMenuSelection)]="selectedRow"
            class="modern-table"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} clinics"
            [rowsPerPageOptions]="[5, 10, 25, 50]"
          >
            <ng-template pTemplate="caption">
              <div class="table-search">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    name="globalFilter"
                    (input)="
                      clinicsTable.filterGlobal(
                        getFilterInputValue($event),
                        'contains'
                      )
                    "
                    placeholder="Search clinics..."
                    class="modern-search"
                  />
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr class="table-header">
                <th
                  *ngFor="let col of clinicColumns"
                  [pSortableColumn]="col.field"
                >
                  <div class="header-cell">
                    {{ col.header }}
                  </div>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-clinic let-columns="columns">
              <tr
                class="table-row"
                [pContextMenuRow]="clinic"
                style="cursor: pointer"
                (click)="showClinicDetails(clinic)"
              >
                <td *ngFor="let col of clinicColumns" class="table-cell">
                  <div class="cell-content" *ngIf="col.field !== 'actions'">
                    <span *ngIf="col.field == 'is_active'">
                      <span
                        [ngClass]="{
                          'status-badge enabled': clinic.is_active,
                          'status-badge disabled': !clinic.is_active
                        }"
                        [style.background]="
                          clinic.is_active
                            ? 'linear-gradient(135deg, rgba(34, 197, 94, 0.2) 0%, rgba(22, 163, 74, 0.2) 100%)'
                            : 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(220, 38, 38, 0.2) 100%)'
                        "
                        [style.color]="clinic.is_active ? '#15803d' : '#dc2626'"
                        [style.border]="
                          clinic.is_active
                            ? '2px solid rgba(34, 197, 94, 0.3)'
                            : '2px solid rgba(239, 68, 68, 0.3)'
                        "
                        [style.padding]="'0.5rem 1rem'"
                        [style.borderRadius]="'20px'"
                        [style.fontSize]="'0.75rem'"
                        [style.fontWeight]="'700'"
                        [style.textTransform]="'uppercase'"
                        [style.letterSpacing]="'0.5px'"
                        [style.display]="'inline-flex'"
                        [style.alignItems]="'center'"
                        [style.justifyContent]="'center'"
                        [style.minWidth]="'80px'"
                        [style.textAlign]="'center'"
                        [style.boxShadow]="
                          clinic.is_active
                            ? '0 2px 8px rgba(34, 197, 94, 0.2)'
                            : '0 2px 8px rgba(239, 68, 68, 0.2)'
                        "
                      >
                        {{ clinic.is_active ? "Enabled" : "Disabled" }}
                      </span>
                    </span>
                    <span *ngIf="col.field != 'is_active'" class="cell-text">{{
                      clinic[col.field]
                    }}</span>
                  </div>
                  <div
                    class="cell-content actions-cell"
                    *ngIf="
                      col.field === 'actions' &&
                      currentRole !== 'hq-clinic-user'
                    "
                  >
                    <button
                      pButton
                      pRipple
                      type="button"
                      icon="pi pi-ellipsis-v"
                      class="p-button-text p-button-rounded p-button-sm action-button"
                      (click)="showContextMenu($event, clinic)"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="clinicColumns.length" class="empty-state">
                  <p-progressBar
                    *ngIf="metaData.loading"
                    mode="indeterminate"
                  ></p-progressBar>
                  <div
                    *ngIf="
                      !metaData.loading && currentRole !== 'hq-clinic-user'
                    "
                    class="empty-content"
                  >
                    <i class="pi pi-building empty-icon"></i>
                    <h3>No clinics found</h3>
                    <p>Get started by registering your first clinic</p>
                    <button
                      pButton
                      pRipple
                      label="Register Clinic"
                      icon="pi pi-plus"
                      class="modern-button secondary"
                      (click)="showRegisterClinicDialog()"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>

    <!-- Users Tab -->
    <p-tabPanel  *ngIf="currentRole !== 'hq-clinic-user'" header="HQ-Users" leftIcon="pi pi-users">
      <div class="tab-content">
        <div class="content-header">
          <div class="header-info">
            <h2 class="section-title">HQ Admins</h2>
            <p class="section-description">
              Manage head office users and permissions
            </p>
          </div>
          <button
            *ngIf="currentRole !== 'hq-clinic-user'"
            pButton
            pRipple
            label="Register User"
            icon="pi pi-plus"
            class="modern-button primary"
            (click)="showUserRegisterDialog('head-office-user')"
          ></button>
        </div>

        <div class="table-container">
          <p-table
            #headOfficeUsersTable
            [value]="users"
            [lazy]="true"
            [paginator]="true"
            (onLazyLoad)="loadHeadOfficeUsersLazy($event)"
            [scrollable]="true"
            scrollDirection="both"
            [totalRecords]="headOfficeMetaData.totalRecords"
            [loading]="headOfficeMetaData.loading"
            [rows]="10"
            class="modern-table"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
            [rowsPerPageOptions]="[5, 10, 25, 50]"
          >
            <ng-template pTemplate="caption">
              <div class="table-search">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    name="globalFilter"
                    (input)="
                      headOfficeUsersTable.filterGlobal(
                        getFilterInputValueForHeadOffice($event),
                        'contains'
                      )
                    "
                    placeholder="Search users..."
                    class="modern-search"
                  />
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr class="table-header">
                <th *ngFor="let key of userColumns">
                  <div class="header-cell">
                    {{ key.header }}
                  </div>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user let-columns="columns">
              <tr class="table-row">
                <td *ngFor="let key of userColumns" class="table-cell">
                  <div class="cell-content">
                    <span class="cell-text">{{ user[key.field] }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="userColumns.length" class="empty-state">
                  <p-progressBar
                    *ngIf="headOfficeMetaData.loading"
                    mode="indeterminate"
                  ></p-progressBar>
                  <div
                    *ngIf="
                      !headOfficeMetaData.loading &&
                      currentRole !== 'hq-clinic-user'
                    "
                    class="empty-content"
                  >
                    <i class="pi pi-users empty-icon"></i>
                    <h3>No users found</h3>
                    <p>Get started by registering your first user</p>
                    <button
                      pButton
                      pRipple
                      label="Register User"
                      icon="pi pi-plus"
                      class="modern-button secondary"
                      (click)="showUserRegisterDialog('head-office-user')"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="content-header mt-4">
          <div class="header-info">
            <h2 class="section-title">HQ Users</h2>
          </div>
        </div>
        <div class="table-container">
          <p-table
            #HqUsersTable
            [value]="hq_users"
            [lazy]="true"
            [paginator]="true"
            (onLazyLoad)="loadHqUsersLazy($event)"
            [scrollable]="true"
            scrollDirection="both"
            [totalRecords]="hqMetaData.totalRecords"
            [loading]="hqMetaData.loading"
            [rows]="10"
            class="modern-table"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
            [rowsPerPageOptions]="[5, 10, 25, 50]"
          >
            <ng-template pTemplate="caption">
              <div class="table-search">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    name="globalFilter"
                    (input)="
                      HqUsersTable.filterGlobal(
                        getfilterInputValueForHq($event),
                        'contains'
                      )
                    "
                    placeholder="Search users..."
                    class="modern-search"
                  />
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr class="table-header">
                <th *ngFor="let key of userColumns">
                  <div class="header-cell">
                    {{ key.header }}
                  </div>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-user let-columns="columns">
              <tr class="table-row">
                <td *ngFor="let key of userColumns" class="table-cell">
                  <div class="cell-content">
                    <span class="cell-text">{{ user[key.field] }}</span>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="userColumns.length" class="empty-state">
                  <p-progressBar
                    *ngIf="hqMetaData.loading"
                    mode="indeterminate"
                  ></p-progressBar>
                  <div
                    *ngIf="
                      !hqMetaData.loading && currentRole !== 'hq-clinic-user'
                    "
                    class="empty-content"
                  >
                    <i class="pi pi-users empty-icon"></i>
                    <h3>No users found</h3>
                    <p>Get started by registering your first user</p>
                    <button
                      pButton
                      pRipple
                      label="Register User"
                      icon="pi pi-plus"
                      class="modern-button secondary"
                      (click)="showUserRegisterDialog('head-office-user')"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>

    <!-- Nurses Tab -->
    <p-tabPanel header="Nurses" leftIcon="pi pi-user">
      <div class="tab-content">
        <div class="content-header">
          <div class="header-info">
            <h2 class="section-title">Nurse Management</h2>
            <p class="section-description">Register and manage nursing staff</p>
          </div>
          <button
            *ngIf="currentRole !== 'hq-clinic-user'"
            pButton
            pRipple
            label="Register Nurse"
            icon="pi pi-plus"
            class="modern-button primary"
            (click)="showCreateNurseDialog()"
          ></button>
        </div>

        <div class="table-container">
          <p-table
            #nursesTable
            [value]="nurses"
            [paginator]="true"
            [rows]="10"
            [lazy]="true"
            (onLazyLoad)="loadNursesLazy($event)"
            [scrollable]="true"
            scrollDirection="both"
            [totalRecords]="nurseMetaData.totalRecords"
            [loading]="nurseMetaData.loading"
            [contextMenu]="nurseCm"
            [(contextMenuSelection)]="selectedRow"
            class="modern-table"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} nurses"
            [rowsPerPageOptions]="[5, 10, 25, 50]"
          >
            <ng-template pTemplate="caption">
              <div class="table-search">
                <span class="p-input-icon-left">
                  <i class="pi pi-search"></i>
                  <input
                    pInputText
                    type="text"
                    name="globalFilter"
                    (input)="
                      nursesTable.filterGlobal(
                        getFilterInputValueForNurse($event),
                        'contains'
                      )
                    "
                    placeholder="Search nurses..."
                    class="modern-search"
                  />
                </span>
              </div>
            </ng-template>

            <ng-template pTemplate="header">
              <tr class="table-header">
                <th *ngFor="let col of nurseColumns">
                  <div class="header-cell">
                    {{ col.header }}
                  </div>
                </th>
                <th></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-nurse let-columns="columns">
              <tr
                class="table-row"
                [pContextMenuRow]="nurse"
                style="cursor: pointer"
              >
                <td *ngFor="let col of nurseColumns" class="table-cell">
                  <div class="cell-content" *ngIf="col.field !== 'actions'">
                    <span class="cell-text">{{
                      resolveField(nurse, col.field)
                    }}</span>
                  </div>
                  <div
                    class="cell-content actions-cell"
                    *ngIf="col.field === 'actions'"
                  >
                    <button
                      *ngIf="currentRole !== 'hq-clinic-user'"
                      pButton
                      pRipple
                      type="button"
                      icon="pi pi-ellipsis-v"
                      class="p-button-text p-button-rounded p-button-sm action-button"
                      (click)="showNurseContextMenu($event, nurse)"
                    ></button>
                    <button
                      pButton
                      pRipple
                      type="button"
                      label="Reset Password"
                      icon="pi pi-envelope"
                      class="p-button-sm action-button--text reset-btn"
                      (click)="sendPasswordResetEmail(nurse.user.email)"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td [attr.colspan]="nurseColumns.length" class="empty-state">
                  <p-progressBar
                    *ngIf="nurseMetaData.loading"
                    mode="indeterminate"
                  ></p-progressBar>
                  <div
                    *ngIf="
                      !nurseMetaData.loading && currentRole !== 'hq-clinic-user'
                    "
                    class="empty-content"
                  >
                    <i class="pi pi-user empty-icon"></i>
                    <h3>No nurses found</h3>
                    <p>Get started by registering your first nurse</p>
                    <button
                      pButton
                      pRipple
                      label="Register Nurse"
                      icon="pi pi-plus"
                      class="modern-button secondary"
                      (click)="showCreateNurseDialog()"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>

<!-- Confirmation dialog -->
<p-confirmDialog
  header="Delete"
  styleClass="modern-confirm-dialog"
  acceptLabel="Yes"
  rejectLabel="Cancel"
  acceptIcon="pi pi-trash"
  rejectIcon="pi pi-times"
  acceptButtonStyleClass="modern-button-accept"
  rejectButtonStyleClass="modern-button-reject"
></p-confirmDialog>
<p-confirmDialog
  header="Toggle"
  key="clinicToggle"
  styleClass="modern-confirm-dialog"
  acceptLabel="Yes"
  rejectLabel="Cancel"
  acceptIcon="pi pi-power-off"
  rejectIcon="pi pi-times"
  acceptButtonStyleClass="modern-button-accept"
  rejectButtonStyleClass="modern-button-reject"
></p-confirmDialog>
<p-confirmDialog
  header="Delete Nurse"
  key="nurseToggle"
  styleClass="modern-confirm-dialog"
  acceptLabel="Yes"
  rejectLabel="Cancel"
  acceptIcon="pi pi-trash"
  rejectIcon="pi pi-times"
  acceptButtonStyleClass="modern-button-accept"
  rejectButtonStyleClass="modern-button-reject"
></p-confirmDialog>
